import config from "../config/config";
import axios, { AxiosRequestHeaders } from "axios";

const baseURI = "https://test.backend.avyaas.com/api/v2/";
// const baseURI = "http://192.168.1.66:5000/api/v2/";

const http = axios.create({
  // baseURL: config.baseURI || baseURI,
  baseURL: baseURI,
  responseType: "json",
});

type getHeaderType = () => AxiosRequestHeaders;
const getHeaders = () => {
  let headerOptions = {
    "Content-Type": "application/json",
    // Authorization: `Bearer `
  };
  return headerOptions;
};

function POST(url: string, data: any) {
  console.log("baseURL in config", config.baseURI);
  let headers = getHeaders();
  return http.post(url, data, { headers: getHeaders() });
}

// import axios, {
//     AxiosError,
//     AxiosInstance,
//     AxiosRequestHeaders,
//     AxiosResponse
//   } from "axios";
//   import config from "../config";
//   import { refreshToken } from "../services/auth";
//   import { getAccessToken } from "../services/token";

//   /* A constant variable that is used to store the base url of the api. */
//   const BaseURL: string = config.baseURI;

//   const http: AxiosInstance = axios.create({
//     baseURL: BaseURL,
//     responseType: "json"
//   });

// type GetHeadersFunction = () => AxiosRequestHeaders;
// const getHeaders: GetHeadersFunction = () => {
//   let headerOptions = {
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${getAccessToken()}`
//   };
//   return headerOptions;
// };

//   function GET(url: string, params: any) {
//     return http.get(url, {
//       headers: getHeaders(),
//       params: params
//     });
//   }

//   function POST(url: string, data: any) {
//     return http.post(url, data, {
//       headers: getHeaders(),
//       params: {}
//     });
//   }

//   function POST_FILE(url: string, data: any) {
//     return http.post(url, data, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${getAccessToken()}`
//       },
//       params: {}
//     });
//   }

//   function PUT(url: string, data: any) {
//     return http.put(url, data, { headers: getHeaders(), params: {} });
//   }

//   function PUT_FILE(url: string, data: any) {
//     return http.put(url, data, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${getAccessToken()}`
//       },
//       params: {}
//     });
//   }

//   /**
//    * It returns a promise that will resolve to the response of a DELETE request to the given url.
//    * @param {string} url - The URL of the API endpoint you want to call.
//    * @returns A function that takes a url and returns a promise.
//    */
//   function REMOVE(url: string) {
//     return http.delete(url, { headers: getHeaders() });
//   }

//   http.interceptors.response.use(
//     response => {
//       return response;
//     },

//     async error => {
//       const originalConfig = error.config;

//       if (error.response.status === 401 && !originalConfig._retry) {
//         originalConfig._retry = true;
//         try {
//           let newAccessToken: string = await refreshToken();
//           console.log(
//             "refresh token after getting succes new token access:",
//             newAccessToken
//           );
//           if (newAccessToken) {
//             originalConfig.headers.Authorization = `Bearer ${newAccessToken}`;
//             return http(originalConfig);
//           }
//         } catch (err) {
//           return Promise.reject(error);
//         }
//       } else {
//         return Promise.reject(error);
//       }
//     }
//   );

export default { POST };
